// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.history.conditionrelatedto.UpdateConditionRelatedToRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateConditionRelatedToRequest extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	accidentDate!: Date | null;

	@GandalfValidator({ sizeString: { message: 'AccidentState cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	accidentState!: string | null;

	@GandalfValidator({ notNull: { message: 'conditionRelatedToId must not be null' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	conditionRelatedToId!: number;

	@GandalfValidator({ notNull: { message: 'relatedToAutoAccident must not be null' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	relatedToAutoAccident!: boolean;

	@GandalfValidator({ notNull: { message: 'relatedToEmployment must not be null' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	relatedToEmployment!: boolean;

	@GandalfValidator({ notNull: { message: 'relatedToOtherAccident must not be null' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	relatedToOtherAccident!: boolean;

}
